import { Pipe, PipeTransform } from '@angular/core';
import { Address } from 'src/lib/fliko/models/person/address.data';
import { LocalizationHelper } from '../helpers/localization.helper';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {
  private readonly locHelper = new LocalizationHelper(this.ls);
  constructor(private ls: LocalizationService) {}

  transform(value: Address | null | undefined, line = 0, placeholder?: string): string {
    return value ? this.locHelper.addressToString(value, line, true) : placeholder ?? '';
  }
}
